import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { agnostify } from '@sainsburys-tech/boltui-utils'

import * as Styled from './ProductDocuments.styles'

class ProductDocuments extends Component {
  render() {
    const isMatch = (value, index, array) => array.indexOf(value) >= index
    const documents = this.props.documents.filter(isMatch)

    const documentList = documents.map((href, key) => {
      const isProductInformation = href.includes('D010')
      let linkLabel = ''

      if (this.props.pdfDescriptions[href]) linkLabel = this.props.pdfDescriptions[href]
      else linkLabel = isProductInformation ? 'View Product Information Sheet (PDF)' : 'View document (PDF)'

      return (
        <li key={key}>
          <a className='a' href={agnostify(href)} target='_blank' rel='noreferrer'>
            {linkLabel}
          </a>
        </li>
      )
    })

    return (
      <Styled.ProductDocuments ref='product-documents' data-test='product-documents'>
        {documentList}
      </Styled.ProductDocuments>
    )
  }
}

ProductDocuments.propTypes = {
  documents: PropTypes.array
}

export default ProductDocuments
